import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

interface ContentProps {
  height?: number | string;
  heightMdDown?: number | string;
  heightSmDown?: number | string;
}

export const MinHeightContainer = styled('div')<ContentProps>`
  ${({ height }) => height && `min-height: ${height}px;`}
  ${media.smDown`
		${({ heightSmDown }) =>
      heightSmDown && heightSmDown && `min-height: ${heightSmDown}px;`}
	`}
  ${media.mdDown`
		${({ heightMdDown }) =>
      heightMdDown && heightMdDown && `min-height: ${heightMdDown}px;`}
	`}
`;
